// extracted by mini-css-extract-plugin
export default {"form":"style_form__PCroD","error":"style_error__yRHhw"};